"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BobTVSiteInterfaceError = exports.BobTVSiteInterface = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// ES6 extend'ing is not working, http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript
var BobTVSiteInterfaceError = function BobTVSiteInterfaceError(message) {
  this.name = 'BobTVSiteInterfaceError';
  this.message = message;
  this.stack = new Error().stack;
};
exports.BobTVSiteInterfaceError = BobTVSiteInterfaceError;
BobTVSiteInterfaceError.prototype = Object.create(Error.prototype);
BobTVSiteInterfaceError.prototype.constructor = BobTVSiteInterfaceError;
var BobTVSiteInterface = /*#__PURE__*/function () {
  /**
   * @param {string} langPath
   */
  function BobTVSiteInterface() {
    var langPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
    _classCallCheck(this, BobTVSiteInterface);
    this.axios = _axios["default"].create({
      baseURL: langPath
    });
    this.axios.interceptors.response.use(this._responseResolveInterceptor, this._responseErrorInterceptor);
  }
  _createClass(BobTVSiteInterface, [{
    key: "_responseResolveInterceptor",
    value: function _responseResolveInterceptor(response) {
      var _response = response.data;
      if (!_response.status || _response.status !== 'success') {
        var error = new BobTVSiteInterfaceError(_response.message || _response.messages || '');
        //console.log('BobTVSiteInterface._responseResolveInterceptor()', error instanceof BobTVSiteInterfaceError);
        return Promise.reject(error);
      }
      return Promise.resolve(response);
    }
  }, {
    key: "_responseErrorInterceptor",
    value: function _responseErrorInterceptor(error) {
      return Promise.reject(error);
    }

    /**
     * Sets required auth params to be sent with all site API requests
     *
     * @param {object} params
     */
  }, {
    key: "setAuthParams",
    value: function setAuthParams(params) {
      this._authParams = params;
    }
  }, {
    key: "getRequestData",
    value: function getRequestData(params) {
      var mergedData = _objectSpread(_objectSpread({}, this._authParams), params);
      var searchParams = new URLSearchParams();
      for (var param in mergedData) {
        searchParams.append(param, mergedData[param]);
      }
      return searchParams;
    }
  }, {
    key: "getWallMaterial",
    value: function getWallMaterial(id) {
      return this.axios.get('/_backend/wall_material/', {
        params: {
          id: id
        }
      });
    }
  }, {
    key: "follow",
    value: function follow(user) {
      return this.axios.post('/_backend/member/follow/', this.getRequestData({
        id: user.uid
      }));
    }
  }, {
    key: "unfollow",
    value: function unfollow(user) {
      return this.axios.post('/_backend/member/unfollow/', this.getRequestData({
        id: user.uid
      }));
    }
  }, {
    key: "block",
    value: function block(user, reason, type) {
      return this.axios.post('/_backend/member/block/', this.getRequestData({
        id: user.uid,
        reason: reason,
        type: type
      }));
    }
  }, {
    key: "setFCMToken",
    value: function setFCMToken(token) {
      return this.axios.post('/_backend/member/pushapi/set-token/', this.getRequestData({
        token: token
      }));
    }
  }, {
    key: "unblock",
    value: function unblock(user) {
      return this.axios.post('/_backend/member/unblock/', this.getRequestData({
        id: user.uid
      }));
    }
  }, {
    key: "giveToken",
    value: function giveToken(recipient_id, amount, room_id, serverId, pm) {
      return this.axios.post('/_backend/member/wallet/give-token/', this.getRequestData({
        amount: amount,
        room_id: room_id,
        "private": pm ? 1 : 0,
        server_id: serverId,
        recipient_id: recipient_id
      }));
    }
  }, {
    key: "setUserMood",
    value: function setUserMood(props) {
      return this.axios.post('/_backend/member/chat-settings/set/', this.getRequestData({
        mood: props.mood,
        pm_enabled: props.pm_enabled,
        mood_visible: props.mood_visible
      }));
    }
  }, {
    key: "getUserMoodText",
    value: function getUserMoodText() {
      return this.axios.post('/_backend/member/chat-settings/');
    }
  }, {
    key: "getDonateInfo",
    value: function getDonateInfo() {
      return this.axios.post('/_backend/payment/wallet/record/');
    }
  }, {
    key: "getExclusionReasons",
    value: function getExclusionReasons() {
      return this.axios.post('/_backend/exclude/reasons/');
    }
  }, {
    key: "excludeUser",
    value: function excludeUser(props) {
      return this.axios.post('/_backend/exclude/', this.getRequestData(_objectSpread({}, props)));
    }
  }, {
    key: "login",
    value: function login(props) {
      return this.axios.post('/_backend/login/', this.getRequestData(_objectSpread({}, props)));
    }
  }, {
    key: "register",
    value: function register(props) {
      return this.axios.post('/_backend/register/', this.getRequestData(_objectSpread({}, props)));
    }
  }, {
    key: "passwordRecover",
    value: function passwordRecover(props) {
      return this.axios.post('/_backend/password_recover/send.php', this.getRequestData(_objectSpread({}, props)));
    }
  }, {
    key: "activateByCode",
    value: function activateByCode(props) {
      return this.axios.post('/_backend/member/activate/by-code/', this.getRequestData(_objectSpread({}, props)));
    }
  }, {
    key: "activateRequestSMS",
    value: function activateRequestSMS(props) {
      return this.axios.post('/_backend/member/activate/request-sms/', this.getRequestData(_objectSpread({}, props)));
    }
  }, {
    key: "getMemberNotificationList",
    value: function getMemberNotificationList() {
      return this.axios.get('/_backend/member/notification/', {
        params: {
          unread: 1
        }
      });
    }
  }, {
    key: "applyMemberNotificationAction",
    value: function applyMemberNotificationAction(_ref) {
      var ids = _ref.ids;
      return this.axios.post('/_backend/member/notification/action/', this.getRequestData({
        ids: ids,
        action: 'read'
      }));
    }
  }, {
    key: "refreshParentWindowUser",
    value: function refreshParentWindowUser() {
      if (window.opener && window.opener.postMessage) {
        try {
          window.opener.postMessage('refresh_current_user', '*');
        } catch (e) {}
      }
    }

    /**
     * @param {File} file
     */
  }, {
    key: "attachmentUpload",
    value: function attachmentUpload(file) {
      var formData = new FormData();
      for (var name in this._authParams) {
        formData.append(name, this._authParams[name]);
      }
      formData.append('upload', file);
      return this.axios.post('/_backend/att/upload/', formData);
    }

    /**
     * @param {object} attachment
     * @param {string} attachment.id
     * @return {*}
     */
  }, {
    key: "attachmentDelete",
    value: function attachmentDelete(attachment) {
      return this.axios.post('/_backend/att/delete/', this.getRequestData({
        id: attachment.id
      }));
    }
  }, {
    key: "mute",
    value: function mute(props) {
      return this.axios.post('/_backend/user/text/mute/', this.getRequestData(_objectSpread({}, props)));
    }
  }, {
    key: "unmute",
    value: function unmute(props) {
      return this.axios.post('/_backend/user/text/unmute/', this.getRequestData(_objectSpread({}, props)));
    }
  }, {
    key: "incrementWallItemViews",
    value: function incrementWallItemViews(props) {
      return this.axios.post('/_backend/member/wall/view/', this.getRequestData(_objectSpread({}, props)));
    }
  }, {
    key: "setRoomOptions",
    value: function setRoomOptions(props) {
      return this.axios.post('/_backend/member/room/update/', this.getRequestData(_objectSpread({}, props)));
    }
  }]);
  return BobTVSiteInterface;
}();
exports.BobTVSiteInterface = BobTVSiteInterface;